import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';
import { MyST } from './MyST.js';
const iconClass = 'inline-block pl-2 mr-2 -translate-y-[1px]';
export const SummaryTitle = ({ node }) => {
    return _jsx(MyST, { ast: node.children });
};
export function Details({ title, children, open, }) {
    return (_jsxs("details", { className: classNames('rounded-md my-5 shadow dark:shadow-2xl dark:shadow-neutral-900 overflow-hidden', 'bg-gray-50 dark:bg-stone-800'), open: open, children: [_jsx("summary", { className: classNames('m-0 text-lg font-medium py-1 min-h-[2em] pl-3', 'cursor-pointer hover:shadow-[inset_0_0_0px_30px_#00000003] dark:hover:shadow-[inset_0_0_0px_30px_#FFFFFF03]', 'bg-gray-100 dark:bg-slate-900'), children: _jsxs("span", { className: "text-neutral-900 dark:text-white", children: [_jsx("span", { className: "block float-right text-sm font-thin text-neutral-700 dark:text-neutral-200", children: _jsx(ChevronRightIcon, { width: "1.5rem", height: "1.5rem", className: classNames(iconClass, 'details-toggle', 'transition-transform') }) }), title] }) }), _jsx("div", { className: "px-4 py-1 details-body", children: children })] }));
}
export const DetailsRenderer = ({ node }) => {
    const [title, ...rest] = node.children;
    return (_jsx(Details, { title: _jsx(MyST, { ast: [title] }), open: node.open, children: _jsx(MyST, { ast: rest }) }));
};
const DROPDOWN_RENDERERS = {
    details: DetailsRenderer,
    summary: SummaryTitle,
};
export default DROPDOWN_RENDERERS;
